import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { uploadApp } from '../../redux/ducks/storeDuck';

import Container from '../../components/Container';
import Button from '../../components/LinkButton';
import ImagePicker from '../../components/ImagePicker';
import Input from '../../components/Input';
import Text from '../../components/Text';
import FilePicker from '../../components/FilePicker';
import OSIcon from '../../components/SoIcon';

function AppsForm({
  uploadApp,
}) {
  const history = useHistory();
  const [state, setState] = useState({
    name: '',
    icon: null,
    android: {
      file: null,
      version: '',
    },
    ios: {
      manifest: null,
      ipa: null,
      version: '',
    },
  });

  const handleSubmit = event => {
    event.preventDefault();
    uploadApp(state);
  };

  return (
    <Container className="dashboard-container admin-apps-form">
      <Button flat onClick={() => history.goBack()} textColor="normal">
        ⬅
      </Button>
      <form>
        <div className="app-name">
          <ImagePicker
            onChange={file => setState(prevState => ({ ...prevState, icon: file }))}
            value={state.icon}
          />
          <Input
            label="Nombre"
            value={state.name}
            onChange={({ target }) => setState(prevState => ({ ...prevState, name: target.value }))}
          />
        </div>
        <div className="app-os">
          <div className="app-os-container">
            <Text placement="center" level="h3" textColor="highlight">
              Android
            </Text>
            <OSIcon so="android" />
            <Input
              label="Versión"
              value={state.android.version}
              onChange={({ target }) => setState(prevState => ({ ...prevState, android: { ...prevState.android, version: target.value } }))}
            />
            <FilePicker
              label="APK"
              onChange={file => setState(prevState => ({ ...prevState, android: { ...prevState.android, file } }))}
              value={state.android.file}
              accept={'.apk'}
            />
          </div>
          <div className="app-os-container">
            <Text placement="center" level="h3" textColor="highlight">
              iOS
            </Text>
            <OSIcon so="ios" />
            <Input
              label="Versión"
              value={state.ios.version}
              onChange={({ target }) => setState(prevState => ({ ...prevState, ios: { ...prevState.ios, version: target.value } }))}
            />

            <FilePicker
              label="Manifest"
              onChange={file => setState(prevSate => ({ ...prevSate, ios: { ...prevSate.ios, manifest: file } }))}
              value={state.ios.manifest}
              accept={'.plist'}
            />

            <FilePicker
              label="IPA"
              onChange={file => setState(prevSate => ({ ...prevSate, ios: { ...prevSate.ios, ipa: file } }))}
              value={state.ios.ipa}
              accept={'.ipa'}
            />
          </div>
        </div>
        <div className="app-send">
          <Button onClick={handleSubmit}>
            Subir
          </Button>
        </div>
      </form>
    </Container>
  );
}

export default connect(
  null, {
    uploadApp,
  }
)(AppsForm);
